var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C12.8203 0.5 13.5 1.17969 13.5 2V8.75C13.5 9.59375 12.8203 10.25 12 10.25H8.50781L8.74219 11.375H9.9375C10.2422 11.375 10.5 11.6328 10.5 11.9375C10.5 12.2656 10.2422 12.5 9.9375 12.5H3.5625C3.23438 12.5 3 12.2656 3 11.9375C3 11.6328 3.23438 11.375 3.5625 11.375H4.73438L4.96875 10.25H1.5C0.65625 10.25 0 9.59375 0 8.75V2C0 1.17969 0.65625 0.5 1.5 0.5H12ZM7.59375 11.375L7.35938 10.25H6.11719L5.88281 11.375H7.59375ZM12.375 8.75V2C12.375 1.8125 12.1875 1.625 12 1.625H1.5C1.28906 1.625 1.125 1.8125 1.125 2V8.75C1.125 8.96094 1.28906 9.125 1.5 9.125H12C12.1875 9.125 12.375 8.96094 12.375 8.75Z",
    fill: "#1D2132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplay);
export default __webpack_public_path__ + "static/media/display.56ac3b628aed0ec8d6667a8b3fac5944.svg";
export { ForwardRef as ReactComponent };